import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * Similar to Angular HttpClient but ignores all interceptors
 */
@Injectable({
  providedIn: 'root',
})
export class PureHttpClientService extends HttpClient {
  constructor(httpBackend: HttpBackend) {
    super(httpBackend);
  }
}
